let moment = require("moment");
export default{
    day(time){
        if(!time){
            return time
        }else if(time.toString().length==10){
            time=time*1000
        }
        return moment(time).format('YYYY-MM-DD hh:mm:ss')
    }
}